import React, { useState } from 'react'
import { Contract } from '@mobi/web-native-comms'
import { isReactNativeApp, sendToNative, subscribeToNative } from '@mobi/web-native-comms/web'

export function useBiometricsStatus() {
  const [isBiometricsStatusReady, setIsBiometricsStatusReady] = useState(false)
  const [isBiometricsEnabled, setIsBiometricsEnabled] = useState(false)
  const [status, setStatus] = useState<Contract['RESPONSE_BIOMETRICS_STATUS'] | undefined>()

  React.useEffect(() => {
    if (!isReactNativeApp) return

    const { dispose } = subscribeToNative('RESPONSE_BIOMETRICS_STATUS', payload => {
      const { isEnabled } = payload
      setIsBiometricsEnabled(isEnabled)
      setIsBiometricsStatusReady(true)
      setStatus(payload)
    })

    sendToNative('REQUEST_BIOMETRICS_STATUS')

    return () => {
      dispose?.()
    }
  }, [])

  return {
    isBiometricsStatusReady,
    isBiometricsEnabled,
    biometricsStatus: status,
  }
}
